import { render, staticRenderFns } from "./PurchasesInvoiceViewGlobal.vue?vue&type=template&id=f4e54a2e"
import script from "./PurchasesInvoiceViewGlobal.vue?vue&type=script&lang=js"
export * from "./PurchasesInvoiceViewGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports